// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3-A4i","cell":"ColumnAccessor_cell__3CWSs","firstCellAccent":"ColumnAccessor_firstCellAccent__uQ30O"};